import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import OrganizationUsage from '@/components/organization/OrganizationUsage.vue';
import { useAside } from '@orion.ui/orion';

type Props = SetupProps<typeof CarouselOrganizationSetupService.props>

export default class CarouselOrganizationSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	get organizationCarouselButtonLabel () {
		if (this.organizationGuard() && this.self.canOneOf('OrganizationRead', 'OrganizationCreate')) {
			return `Voir mon organisation`;
		} else if (!this.organizationGuard() && this.self.can('OrganizationCreate')) {
			return `Créer mon organisation`;
		} else {
			return `En savoir plus`;
		}
	}

	constructor (props?: Props) {
		super(props);
	}

	handleOrganizationCarouselRedirection () {
		if (this.self.canOneOf('OrganizationCreate', 'OrganizationRead')) {
			this.router.push({ name: 'OrganizationDashboard' });
		} else {
			useAside({
				Nested: OrganizationUsage,
				customClass: 'organization-usage-aside',
			});
		}
	}
}
